import React, { useEffect, useState } from 'react'

import { NAMES_ES } from "../../../assets/appConstants/constants";
import CopyToClipboard from "../../common/CopyToClipboard";
import { TableColumn } from "../../../models/dataTable.model";
import { DataTicket } from "../../../models/ticket.model";
import { Link } from "react-router-dom";
import { closedTicketsTable } from '../../../services/report.service';
import { useProject } from '../../../context/ProjectContext';
import { APIResponseModel } from '../../../models/api-call';
import DataTable from '../../common/DataTable2';
import { getPriorityColor } from '../../../utilities/functions';
import { useNotification } from '../../../context/NotificationContext';


const TableSchema: TableColumn[] = [
  { key: 'number', name: NAMES_ES.number, width: '10%' },
  { key: 'failure_date', name: NAMES_ES.failure_date, width: '12%' },
  { key: 'title_name', name: NAMES_ES.title, width: '8%' },
  { key: 'element_name', name: NAMES_ES.element, width: '10%' },
  { key: 'company_name', name: NAMES_ES.company, width: '10%' },
  { key: 'priority_name', name: NAMES_ES.priority, width: '10%' },
  { key: 'area_name', name: NAMES_ES.area, width: '8%' },
  { key: 'closing_date', name: NAMES_ES.closing_date, width: '12%' },
  { key: 'ttr', name: NAMES_ES.ttr, width: '20%' },
]

const columnId: string = 'number'
const rowDetailPath = '/ticket/view/'

const rowDataPreprocesor = (rowData: DataTicket): any => {

  return {
    ...rowData,
    number_render: (
      <div className='tickets-table-column-number'>
        <span>
          <Link target="_blank" rel="noopener noreferrer" className="tickets-table-column-number__link" to={`/${rowData.project_code}${rowDetailPath}${rowData.number}/0`}>
            {rowData.number}
          </Link>
        </span>

        <div className='tickets-table-column-number__copyicon'>
          <CopyToClipboard targetText={rowData.number as string} />
        </div>
      </div>
    ),
    priority_name_render: (
      <div className="tickets-table-column-priority"
        style={{ backgroundColor: getPriorityColor(rowData.priority_code ?? '') }}
      >
        {rowData.priority_name}
      </div>
    ),
  }
}

interface ResolutionTimeTableWidgetProps {
  filters: { from: string, to: string, [key: string]: any }
  reload?: boolean

}

const ResolutionTimeTableWidget: React.FC<ResolutionTimeTableWidgetProps> = ({
  filters,
  reload = false
}) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification()

  const [dataTable, setDataTable] = useState<DataTicket[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  // const defaultTicketsFilter: any = {
  //   status: { 'id': 'ST3', 'label': 'Cerrado' },
  //   project_id: selectedProject
  // }

  const initComponent = () => {
    setLoading(true)
    Promise.all([closedTicketsTable(selectedProject, filters)
    ]).then(function (result: APIResponseModel[]) {
      setDataTable(result[0].data)
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
      showNotification(<span>{error.response.data}</span>, 'error')
    });
  }

  useEffect(initComponent, [reload])

  return (
    <React.Fragment>
      <DataTable
        columns={TableSchema}
        rows={dataTable.map(rowDataPreprocesor)}
        loading={loading}
        columnId='number'
        onRowDoubleClick={() => { }}

      />

    </React.Fragment>
  )
}

export default ResolutionTimeTableWidget;

